export interface ITestReport {
  key: string;
  testName: string;
  date: string;
  lastModified: string;
  size: number;
}

export interface IListTestReportsResponse {
  listTestReports: ITestReport[];
}

export const listTestReportsQuery = `
  query($prefix: String, $days: [String], $testType: String) {
    listTestReports(prefix: $prefix, days: $days, testType: $testType) {
      key
      testName
      date
      lastModified
      size
    }
  }
`;
